import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasCompletedOnboarding } from '@/Pages/Success/types/successLocationState';

const WELCOME_PATH = '/welcome';

type SuccessRouteGuardProps = {
  children: ReactNode;
};

export function SuccessRouteGuard({ children }: SuccessRouteGuardProps) {
  const location = useLocation();

  if (!hasCompletedOnboarding(location.state)) {
    return <Navigate to={WELCOME_PATH} replace />;
  }

  return children;
}
